import {Box, Image, Text, Flex, Icon, useToast} from '@chakra-ui/react'
import {defaultAvatarUrl} from '@utils/Const'
import {ReactComponent as IconSave2} from '@assets/svgs/learn/book_mark_2.svg'
import {ReactComponent as IconSave3} from '@assets/svgs/learn/book_mark_3.svg'
import {CommonColors} from '@utils/CommonStyles'
import Book2Icon from '@assets/svgs/learn/book_2.svg'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateIsOpenModalSaveKnowledge,
  updateTypeSaveFolder,
} from '@redux/notebook/notebookSlice'
import {styleByTextTag} from '@utils'
import {
  updateDataSavePhrase,
  updateIsDisableHandleText,
  updateSavedPhrase,
} from '@redux/conversation/converstationSlice'
import notebookRequest from '@apis/notebook'
import {useEffect, useState} from 'react'
import CheckCircle from '@assets/svgs/learn/check_circle.svg'
import ArrowRight from '@assets/svgs/learn/arrow_right_2.svg'

const ItemSummary = ({message}: {message: any}) => {
  const dispatch = useDispatch()
  const [isDisableBtnSaveSentence, setIsDisableBtnSaveSentence] =
    useState<any>(false)
  const {session_id, savedPhrase} = useSelector(
    (state: any) => state.converstation,
  )
  const toast = useToast()

  useEffect(() => {
    dispatch(updateSavedPhrase(message?.message?.chunk))
  }, [message])

  const handleReview = () => {
    window.open('/learn/notebook', '_blank')
  }

  const handleSaveSentence = async () => {
    const params = {
      sentence: message?.message?.sentence,
      source: 'LESSON',
      session_id: session_id,
    }
    const res = await notebookRequest.saveSentence(params)
    if (res?.status === 200) {
      setIsDisableBtnSaveSentence(true)

      const idToast = toast({
        position: 'bottom-left',
        duration: 7000,
        render: () => (
          <Box
            p={'24px'}
            pb={0}
            bg="white"
            borderRadius={'16px'}
            boxShadow={
              '0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)'
            }
            onClick={() => toast.close(idToast)}>
            <Flex gap={'16px'} fontSize={'16px'} fontWeight={600}>
              <Image src={CheckCircle} />
              <Text>{`Lưu thành công mẫu câu vào Sổ tay kiến thức`}</Text>
            </Flex>
            <Flex justifyContent={'flex-end'} alignItems={'center'}>
              <Flex gap={'10px'} cursor={'pointer'} onClick={handleReview}>
                <Text
                  fontSize={'16px'}
                  fontWeight={700}
                  color={'#1890FF'}
                  pt={'12px'}
                  pb={'24px'}>
                  Xem lại ngay
                </Text>
                <Image src={ArrowRight} />
              </Flex>
            </Flex>
          </Box>
        ),
      })
    }
  }

  const handleSavePhrase = (item: any) => {
    const dataTextSelect = {
      phrase: item.text_en,
      sentence: message?.message?.sentence || '',
      index: 1,
    }
    dispatch(updateIsDisableHandleText(true))
    dispatch(updateIsOpenModalSaveKnowledge(true))
    dispatch(updateTypeSaveFolder('PHRASE'))
    setTimeout(() => {
      dispatch(updateDataSavePhrase(dataTextSelect))
    }, 0)
  }

  const checkIsDisableBtn = (item: any) => {
    if (savedPhrase) {
      const currentPhrase = savedPhrase.find(
        (i: any) => i.text_en === item.text_en,
      )
      return currentPhrase?.is_saved
    }
  }

  return (
    <Box className={`chat-message`}>
      <Image src={defaultAvatarUrl} alt="Avatar" className="avatar" />
      <Box
        borderRadius={'32px'}
        bg={CommonColors.white}
        borderWidth={1}
        borderColor={CommonColors.blue}
        ml={{base: '8px', md: '16px'}}
        minW={'80%'}>
        <Box p={{base: '16px', md: '40px'}}>
          <Flex gap={{base: '4px', md: '8px'}} alignItems={'center'}>
            <Image src={Book2Icon} w={{base: '20px', md: 'auto'}} />
            <Text fontSize={{base: '18px', md: '24px'}} fontWeight={600}>
              {message?.message?.title}
            </Text>
          </Flex>
          <Text
            fontSize={{base: '14px', md: '16px'}}
            my={{base: '12px', md: '16px'}}>
            {styleByTextTag(message?.message?.sentence_description)}
          </Text>
          <Flex
            p={{base: '12px 16px', md: '20px 24px'}}
            bg={'#E6F7FF'}
            borderRadius={'16px'}
            gap={{base: '8px', md: '16px'}}
            flexDirection={{base: 'column', md: 'row'}}
            justifyContent={'space-between'}
            alignItems={{base: 'flex-start', md: 'center'}}>
            <Text
              fontSize={{base: '14px', md: '16px'}}
              fontWeight={600}
              color={'#1890FF'}>
              {message?.message?.sentence}
            </Text>
            {!message?.message.is_sentence_saved &&
              message?.message.is_sentence_saved !== null &&
              !isDisableBtnSaveSentence && (
                <Flex
                  h={'fit-content'}
                  flexShrink={0}
                  p={'6px 15px'}
                  cursor={'pointer'}
                  alignItems={'center'}
                  gap={'10px'}
                  border={'1px solid #BAE7FF'}
                  borderRadius={'12px'}
                  bg={'white'}
                  onClick={handleSaveSentence}>
                  <Icon viewBox="0 0 24 24" w={'24px'} h={'24px'}>
                    <IconSave2 />
                  </Icon>
                  <Text
                    color={'#1890FF'}
                    fontWeight={600}
                    fontSize={{base: '14px', md: '16px'}}>
                    Lưu câu
                  </Text>
                </Flex>
              )}
          </Flex>
          <Text
            my={{base: '12px', md: '16px'}}
            fontSize={{base: '14px', md: '16px'}}>
            {message?.message?.chunk_description}
          </Text>
          <Box border={'1px solid #D9D9D9'} borderRadius={'16px'}>
            {message?.message?.chunk?.map((item: any, index: any) => {
              return (
                <Flex
                  gap={{base: '8px', md: '16px'}}
                  key={index}
                  p={{base: '12px 16px', md: '20px 24px'}}
                  borderTop={index !== 0 ? '1px solid #D9D9D9' : ''}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  flexDirection={{base: 'column', md: 'row'}}>
                  <Flex flexDirection={'column'}>
                    <Text
                      fontWeight={600}
                      fontSize={{base: '14px', md: '16px'}}>
                      {item.text_en}
                    </Text>
                  </Flex>
                  <Flex
                    flexShrink={0}
                    p={'6px 15px'}
                    cursor={'pointer'}
                    alignItems={'center'}
                    gap={'10px'}
                    border={'1px solid #BAE7FF'}
                    borderRadius={'12px'}
                    bg={
                      !item?.is_saved && !checkIsDisableBtn(item)
                        ? 'white'
                        : '#1890FF'
                    }
                    onClick={() => handleSavePhrase(item)}>
                    <Icon w={'24px'} h={'24px'}>
                      {!item?.is_saved && !checkIsDisableBtn(item) ? (
                        <IconSave2 />
                      ) : (
                        <IconSave3 />
                      )}
                    </Icon>
                    <Text
                      color={
                        !item?.is_saved && !checkIsDisableBtn(item)
                          ? '#1890FF'
                          : 'white'
                      }
                      fontWeight={600}
                      fontSize={{base: '14px', md: '16px'}}>
                      {!item?.is_saved && !checkIsDisableBtn(item)
                        ? 'Lưu cụm'
                        : 'Đã lưu'}
                    </Text>
                  </Flex>
                </Flex>
              )
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ItemSummary
